function SourceInspector() {
  var _props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return null;
}
export {
  SourceInspector
};
//# sourceMappingURL=SourceInspector.js.map
